<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"\nbackground: linear-gradient(90deg, #f4978e 0%, #ffe5ec 49%, #ffe5d9 100%);\nheight:100vh;"' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-login-1 v-bind='{...{"image":"https:\/\/api.snowavip.ir\/storage\/icons\/5857593.webp","showPanels":false,"imageParentClass":"col-lg-6 d-none d-lg-block"},...{}}' :style='""' class="col-lg-10 mx-auto mt-5" >
                <template #classic-login-p-1-bottom>   </template>
                
                <template #classic-login-p-1-top>   </template>
                
                <template #two-step-login-p-1-bottom>   </template>
                
                <template #two-step-login-p-1-top>   </template>
                </m-login-1></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mLogin1 from '@moeinmdn/miw-alpha-components/src/package/Authentication/Login/Login1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mLogin1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
